module.exports = __webpack_public_path__ + "static/media/logo_inex_cor.99b2b881.svg";